module.exports = __webpack_public_path__ + "img/product-preview-56.981951e.png";